// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1jBBO","cell":"ColumnAccessor_cell___ixZH","firstCellAccent":"ColumnAccessor_firstCellAccent__2Vkjz"};